import { useTranslation } from "react-i18next";

import { BaseLinkMenuItem, BaseMenuItem } from "./baseMenuItem";
import type {
  IActionMenuItemsProps,
  IDeleteActionMenuItemsProps,
  ILinkMenuItemsProps,
} from "./types";
import {
  actionMenuItemVariant,
  deleteActionMenuItemVariant,
  linkMenuItemVariant,
} from "./variant";

import { showAlert } from "@/stores/uiStore";
import type { ILocaleType } from "@/configs";

export function LinkMenuItem(props: ILinkMenuItemsProps) {
  const baseProps = linkMenuItemVariant[props.type];

  return <BaseLinkMenuItem to={props.to} {...baseProps} />;
}

export function ActionMenuItem(props: IActionMenuItemsProps) {
  const { t } = useTranslation("alerts");
  const { showAlertProps, ...rest } = actionMenuItemVariant[props.type];

  return (
    <BaseMenuItem
      onClick={() => {
        if (showAlertProps) {
          showAlert({
            title: t(showAlertProps.title),
            type: showAlertProps.type,
            onApprove() {
              props.onClick();
            },
          });
        } else {
          props.onClick();
        }
      }}
      {...rest}
    />
  );
}

function selectName(locale: ILocaleType, faName: string, enName: string) {
  switch (locale) {
    case "fa":
      return faName;
    case "en":
      return enName;

    default:
      return enName;
  }
}

export function DeleteActionMenuItem(props: IDeleteActionMenuItemsProps) {
  const { t } = useTranslation("alerts");
  const {
    color = "danger-main",
    iconName = "TrashBinTrash",
    title,
    ...rest
  } = deleteActionMenuItemVariant[props.type];

  const { i18n } = useTranslation();

  const language = i18n.language as ILocaleType;

  const name =
    typeof props.name === "string"
      ? props.name
      : selectName(language, props.name.fa, props.name.en);

  return (
    <BaseMenuItem
      onClick={() => {
        showAlert({
          title: t(rest.showAlertProps?.title || "alert.delete", { name }),
          type: rest.showAlertProps?.type || "delete",

          onApprove: async () => {
            await props.onClick();
          },
        });
      }}
      title={title}
      color={color}
      iconName={iconName}
      {...rest}
    />
  );
}
